import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

const CarouselItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;

  .carouselItemValue {
    white-space: nowrap;
    padding: 24px 20px;
    height: 100%;
    background-color: rgba(43, 61, 84, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  @media (max-width: 1400px) {
    .carouselItemValue {
      padding: 15px 10px;
      font-size: 12px;
    }
  }

  .carouselItemContent {
    margin-left: 15px;
  }

  .carouselItemText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
  }

  .carouselItemTitle {
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: #2b3d54;
    border-bottom: 1px solid rgba(43, 61, 84, 0.1);
    margin-bottom: 10px;
  }

  .carouselItemSub {
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .carouselItemDate {
    color: #2b3d54;
    opacity: 0.5;
    font-size: 10px;
    line-height: 1;
  }
`;

const CarouselItem = ({
  price,
  date,
  displayed_currency,
  wine_name,
  bottle_vintage,
  type,
  bottle_format,
  store_name,
  market_name
}) => (
  <CarouselItemContainer>
    <div className="carouselItemValue">
      <div>
        {price
          ? price.toLocaleString('fr-FR', {
              style: 'currency',
              currency: displayed_currency ? displayed_currency : 'EUR',
              minimumFractionDigits: 1,
              maximumFractionDigits: 1
            })
          : 'ND'}
      </div>
    </div>
    <div className="carouselItemContent">
      <p className="carouselItemTitle">{type}</p>

      <div>
        <p className="carouselItemSub">{`${store_name} ${market_name}`}</p>
      </div>
      <div>
        <p className="carouselItemSub">{`${wine_name} ${bottle_vintage} - ${
          bottle_format && bottle_format + ' ml'
        }`}</p>
      </div>
      <div>
        <p className="carouselItemDate"> {moment(date).format('DD/MM/YYYY')}</p>
      </div>
    </div>
  </CarouselItemContainer>
);

export default CarouselItem;
